import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useCart } from "../stores/hooks/useCart";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { OrderDetails, cartSlice } from "../stores/slices/cartSlice";

const getVersion = (cartData?: OrderDetails | null): number => {
  if (!cartData) {
    return 0;
  }
  return new Date(cartData.orderLastUpdatedTimestamp).getTime();
};

export const useGetCartContents = (
  cartId?: null | string
): ModifiedSWRResponse<FetcherResult<OrderDetails>, OrderDetails> => {
  const cart = useCart();
  const dispatch = useDispatch();
  const dealer = useNullableDealerAccountInfo();
  const { data, ...result } = useSwrGet<OrderDetails>(
    cartId ? "/retailSiteWebService/shopping/cart/getCartContents.php" : null,
    cartId
      ? {
          cartId,
          dealerId: dealer?.dealerId ?? "",
          markAsQuote: "true",
          orderNumber: cartId,
        }
      : {}
  );

  useEffect(() => {
    if (getVersion(data) > getVersion(cart)) {
      const action = cartSlice.actions.next(data);
      dispatch(action);
    }
  }, [cart, data]);

  return { data: cart ?? data, ...result };
};
